/**
 * Código interno de Identity Provider para Keycloak
 * Usado por el backend de authorization service
 * [Inmutable]
 */
const _IDP_KEYCLOAK_CODE = 'KEYCLOAK';

/**
 * URL base del realm de Keycloak (issuer).
 * Realm compartido a nivel organización — confirmar con el equipo de Identity si
 * corresponde reutilizarlo o registrar uno propio para este proyecto.
 */
const _KEYCLOAK_ISSUER_URL = 'https://camunda-custom-dev.fidseguros.com/realms/fid-customer-accounts';

/**
 * Client ID OIDC registrado en Firebase/Identity Platform para hablar con Keycloak.
 * Es un client a nivel del proyecto Firebase (no por app consumidora), reutilizado
 * del proyecto de referencia `fid-architecture-services-dev`.
 */
const _KEYCLOAK_CLIENT_ID = 'oidc-firebase-auth-provider-poc-id';

/**
 * Url del host de la aplicación
 * [Placeholder: reemplazar con el dominio real desplegado del proyecto]
 */
const _HOST_APP = 'https://app.fba.dev.fidseguros.cl';

/**
 * Ruta de redirección cuando el usuario cerró la sesión.
 */
const _REDIRECT_LOGOUT_CONFIRMATION_RUTE = 'logout';

/**
 * URL de redirección después de logout.
 */
const _REDIRECT_POST_LOGOUT_URL = `${_HOST_APP}/${_REDIRECT_LOGOUT_CONFIRMATION_RUTE}`;

/**
 * Environment Configuration
 * --------------------------------------------------------------------
 * Archivo de configuración de entorno para Angular.
 *
 * Este archivo define:
 * - URLs de backend (BFF)
 * - Parámetros de autenticación
 * - Configuración de Identity Providers
 * - Credenciales Firebase / Identity Platform
 *
 * IMPORTANTE:
 * - NO debe contener secretos reales en producción
 * - Para producción usar `environment.production.ts`
 */
export const auth_environment = {

    /**
     * Identificador del proveedor OIDC configurado en Firebase/Identity Platform para Keycloak.
     * Debe coincidir exactamente con el providerId registrado en Firebase Identity Platform.
     */
    PROVIDER_KEYCLOAK_ID: 'oidc.oidc.keycloak.provider',

    /**
     * Modo de login para Keycloak: 'popup' o 'redirect'.
     * En ambientes desplegados usamos redirect (requiere authDomain custom en el
     * mismo site que la app para evitar partición de storage del navegador).
     */
    KEYCLOAK_LOGIN_MODE: 'redirect',

    /**
     * URL de logout de Keycloak (end-session endpoint).
     */
    KEYCLOAK_LOGOUT_URL: `${_KEYCLOAK_ISSUER_URL}/protocol/openid-connect/logout?client_id=${_KEYCLOAK_CLIENT_ID}&post_logout_redirect_uri=${_REDIRECT_POST_LOGOUT_URL}`,

    /**
     * Ruta de redirección si el usuario no tiene acceso al recurso solicitado.
     */
    REDIRECT_UNAUTHORIZED_RUTE: 'unauthorized',

    /**
     * Ruta de redirección si la ruta esta protegida y la sesion no esta activa. Ejemplo: Pagina de Login (login).
     * Importante, esta ruta no debe estar protegida sino entraría en bucle infinito.
     */
    REDIRECT_GUARD_RUTE: 'login',

    /**
     * Código interno de Identity Provider para Keycloak
     * Usado por el backend
     */
    IDP_KEYCLOAK_CODE: `${_IDP_KEYCLOAK_CODE}`,

    /**
     * Si es true, el servicio `user-context` responde con un dummy local
     * (ver mockBffInterceptor) en vez de llamar al BFF real. Desactivar
     * cuando el BFF de autorización definitivo esté disponible.
     */
    USE_MOCK_BFF: true,

    /**
     * URL base del Backend for Frontend (BFF)
     * Todas las llamadas HTTP del frontend pasan por esta URL.
     */
    BFF_BACKEND_URL: 'https://archetype.bff.fidseguros.cl',

    /**
     * Path del servicio que obtiene el contexto del usuario.
     */
    BFF_BACKEND_SERVICE_USER_CONTEXT: '/bff.authorization.service/v1/user-context',

    BFF_BACKEND_SERVICE_CSRF: '/bff.authorization.service/v1/csrf',

    /**
     * Ruta de redirección si ocurre un error al obtener el contexto del usuario.
     */
    REDIRECT_ERROR_AUTHORIZATION_SERVICE_RUTE: 'error_auth_service',

    /**
     * Ruta de redirección después de login.
     */
    REDIRECT_POST_LOGIN_RUTE: 'home',

    /**
     * Configuración oficial de Firebase / Identity Platform.
     * Reutiliza el proyecto de referencia `fid-architecture-services-dev` (mismo
     * proyecto donde ya está registrado el proveedor OIDC de Keycloak). El
     * authDomain (fbauth.fidseguros.cl) comparte "site" con cualquier app bajo
     * *.fidseguros.cl, por lo que el modo 'redirect' funciona sin partición de
     * storage siempre que esta app también se despliegue bajo ese dominio.
     */
    FIREBASE: {
        apiKey: 'AIzaSyDYFoshWimSsgn8VD__HisDtOkvzgEoxEI',
        authDomain: 'fbauth.fidseguros.cl',
        projectId: 'fid-architecture-services-dev',
        storageBucket: 'fid-architecture-services-dev.appspot.com',
        messagingSenderId: '392810073486',
        appId: '1:392810073486:web:06706947a9f1ccc1be68df',
    },
}
